export const TOP_SUPPLIERS: string[] = ['Expedia', 'Hotels.com', 'Booking.com'];
export const REQUEST_CANCEL_RESERVATION = 'request-cancel-reservation';
export const RESERVATION_CANCELLATION = 'reservation-cancellation';
export const HOTEL_SUPPORT_EMAIL = 'hotelsupport@membergetaways.com';
